var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("点击预览PDF")]),_c('el-link',{attrs:{"type":"primary"},on:{"click":_vm.viewPdf}},[_vm._t("default",[_vm._v("查看明细")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }